var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('v-slider',_vm._b({attrs:{"value":_vm.modelValue.tenure,"thumb-label":"always"},on:{"input":(newValue) => (_vm.modelValue.tenure = newValue)}},'v-slider',_vm.$props,false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }